import { gql } from 'graphql-request';

const CreateSettlementQuery = gql`
  mutation CreateSettlement($input: SettlementInput!, $userContractId: Float!) {
    CreateSettlement(input: $input, userContractId: $userContractId) {
      status
      error
      messege
      data
    }
  }
`;
export default CreateSettlementQuery;
